import { render, staticRenderFns } from "./OnBoarding.vue?vue&type=template&id=c0d5864c"
import script from "./OnBoarding.vue?vue&type=script&lang=js"
export * from "./OnBoarding.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports